class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification-wrapper');
    this.drawer = document.getElementById('drawer');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.drawer.classList.add('active');
    document.body.classList.add('overflow-hidden-tablet');
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

renderContents(parsedState) {
  let cartIconBubbleRendered = false; 

  this.getSectionsToRender().forEach((section) => {
    if (!cartIconBubbleRendered) {
      const element = document.getElementById(section.id);
      if (element) {
        if (section.id === 'cart-icon-bubble') {
          element.innerHTML = '';
          element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          cartIconBubbleRendered = true; 
        } else {
          element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      } else {
        console.error(`Element with ID ${section.id} not found.`);
      }
    }
  });

  this.open();
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (element) {
      return element.innerHTML;
    } else {
      console.error(`Element with selector '${selector}' not found.`);
      return ''; // Return an empty string or handle the error as needed
    }
  }

handleBodyClick(evt) {
  const target = evt.target;
  const isCloseButton = target.closest('.cart-notification__close');
  const isDrawer = target.closest('.drawer');
  const isWithinWrapper = target.closest('.cart-notification-wrapper');
  
  if (isCloseButton) {
    this.close();
  } else if (isDrawer && !isWithinWrapper) {
    this.close();
  }
}

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
